import Vue from 'vue';
import Router from 'vue-router';
import Api from '../api/api';
import Http from '../http/http';
const tracking = resolve => require(['@/views/tracking'], resolve);
const playback = resolve => require(['@/views/playback'], resolve);
const warning = resolve => require(['@/views/warning'], resolve);
const set = resolve => require(['@/views/set'], resolve);
const alarmDetails = resolve => require(['@/views/alarmDetails'], resolve);
const instruction = resolve => require(['@/views/instruction'], resolve);
const fence = resolve => require(['@/views/fence'], resolve);
const fenceCreate = resolve => require(['@/views/fenceCreate'], resolve);
const inparticulars = resolve => require(['@/views/inparticulars'], resolve);
const cell = resolve => require(['@/views/cell'], resolve);
const check = resolve => require(['@/views/check'], resolve);
const custom = resolve => require(['@/views/custom'], resolve);
const shutdown = resolve => require(['@/views/shutdown'], resolve);
const sos = resolve => require(['@/views/sos'], resolve);
const starting = resolve => require(['@/views/starting'], resolve);
const alarm = resolve => require(['@/views/alarm'], resolve);
const promptly = resolve => require(['@/views/promptly'], resolve);
const timing = resolve => require(['@/views/timing'], resolve);
const changeCard = resolve => require(['@/views/changeCard'], resolve);
const bootRemind = resolve => require(['@/views/bootRemind'], resolve);
const whitelist = resolve => require(['@/views/whitelist'], resolve);
const amendRail = resolve => require(['@/views/amendRail/amendRail'], resolve);
const RailParticulars = resolve => require(['@/views/RailParticulars/RailParticulars'], resolve);
Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/tracking'
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: tracking,
      meta: {
        keepAlive: true // true 表示需要使用缓存
      }
    },
    {
      path: '/playback',
      name: 'playback',
      component: playback
    },
    {
      path: '/warning',
      name: 'warning',
      component: warning
    },
    {
      path: '/set',
      name: 'set',
      component: set
    },
    {
      path: '/alarmDetails',
      name: 'alarmDetails',
      component: alarmDetails
    },
    {
      path: '/instruction',
      name: 'instruction',
      component: instruction
    },
    {
      path: '/fence',
      name: 'fence',
      component: fence
    },
    {
      path: '/fenceCreate',
      name: 'fenceCreate',
      component: fenceCreate
    },
    {
      path: '/inparticulars',
      name: 'inparticulars',
      component: inparticulars
    },
    {
      path: '/cell',
      name: 'cell',
      component: cell
    },
    {
      path: '/check',
      name: 'check',
      component: check
    },
    {
      path: '/custom',
      name: 'custom',
      component: custom
    },
    {
      path: '/shutdown',
      name: 'shutdown',
      component: shutdown
    },
    {
      path: '/sos',
      name: 'sos',
      component: sos
    },
    {
      path: '/starting',
      name: 'starting',
      component: starting
    },
    {
      path: '/alarm',
      name: 'alarm',
      component: alarm
    },
    {
      path: '/promptly',
      name: 'promptly',
      component: promptly
    },
    {
      path: '/timing',
      name: 'timing',
      component: timing
    },
    {
      path: '/changeCard',
      name: 'changeCard',
      component: changeCard
    },
    {
      path: '/bootRemind',
      name: 'bootRemind',
      component: bootRemind
    },
    {
      path: '/whitelist',
      name: 'whitelist',
      component: whitelist
    },
    {
      path: '/amendRail',
      name: 'AmendRail',
      component: amendRail
    },
    {
      path: '/RailParticulars',
      name: 'RailParticulars',
      component: RailParticulars
    }
  ]
});
router.beforeEach((to, from, next) => {
  $('.mui-toast-message').hide();
  /* 统一校验token */
  if (to.query.token) {
    window.localStorage.setItem('token', to.query.token);
  } else if (!window.localStorage.token) {
    mui.toast('登录状态无效');
  }
  try {
    if(localStorage.getItem('token') && localStorage.getItem('token')!=null){
      if(document.title!="智慧卡"){
          Http.$get(Api.GET_projectShowName, res => {
            if (res.code === 0) {
              document.title = "智慧卡";
              console.log(res,123)
            } else {
                mui.toast(res.msg);
            }
        
          }, { token: localStorage.getItem('token') });
      }
    }
  }
  catch(err) {
    console.log(err)
  }
  finally {
    next();
  }
  // next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js